const scroll = element => element.scrollIntoView({ transition: "smooth", block: "start" });

export const scrollToElement = (element, direct = false) => {
  const { parentElement } = element;
  const el = parentElement && !direct ? parentElement : element;
  scroll(el);
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};
